var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroups3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.48 27.3C30.14 26.26 27.26 25.5 24 25.5C20.74 25.5 17.86 26.28 15.52 27.3C13.36 28.26 12 30.42 12 32.78V36H36V32.78C36 30.42 34.64 28.26 32.48 27.3ZM16.14 32C16.32 31.54 16.68 31.16 17.12 30.96C19.32 29.98 21.64 29.5 23.98 29.5C26.34 29.5 28.64 30 30.84 30.96C31.3 31.16 31.64 31.54 31.82 32H16.14Z",
    fill: "#FFEFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.44 29.16C0.96 29.8 0 31.24 0 32.86V36H9V32.78C9 31.12 9.46 29.56 10.26 28.2C9.52 28.08 8.78 28 8 28C6.02 28 4.14 28.42 2.44 29.16Z",
    fill: "#FFEFEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.56 29.16C43.86 28.42 41.98 28 40 28C39.22 28 38.48 28.08 37.74 28.2C38.54 29.56 39 31.12 39 32.78V36H48V32.86C48 31.24 47.04 29.8 45.56 29.16Z",
    fill: "#FFEFEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24C27.32 24 30 21.32 30 18C30 14.68 27.32 12 24 12C20.68 12 18 14.68 18 18C18 21.32 20.68 24 24 24ZM24 16C25.1 16 26 16.9 26 18C26 19.1 25.1 20 24 20C22.9 20 22 19.1 22 18C22 16.9 22.9 16 24 16Z",
    fill: "#FFEFEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9998 16.9937L2.99353 22L7.9998 27.0063L13.0061 22L7.9998 16.9937Z",
    fill: "#FFEFEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40 18L35 26H45L40 18Z",
    fill: "#FFEFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups3);
export default __webpack_public_path__ + "static/media/groups_3.3f648ee95cc65872fe5dd3b8986f9a94.svg";
export { ForwardRef as ReactComponent };